import s, { createContext as v, forwardRef as m, useContext as h } from "react";
import { cx as P } from "@huspy/styled-system/css";
import { styled as d } from "@huspy/styled-system/jsx";
const y = (c) => {
  const l = v(null);
  return {
    withRootProvider: (e) => (r) => {
      const [o, t] = c.splitVariantProps(r), n = c(o);
      return /* @__PURE__ */ s.createElement(l.Provider, { value: n }, /* @__PURE__ */ s.createElement(e, { ...t }));
    },
    withProvider: (e, r) => {
      const o = d(e);
      return m((t, n) => {
        const [a, u] = c.splitVariantProps(t), i = c(a);
        return /* @__PURE__ */ s.createElement(l.Provider, { value: i }, /* @__PURE__ */ s.createElement(
          o,
          {
            ...u,
            ref: n,
            className: P(i == null ? void 0 : i[r], t.className)
          }
        ));
      });
    },
    withContext: (e, r) => {
      const o = d(e);
      return m((t, n) => {
        const a = h(l);
        return /* @__PURE__ */ s.createElement(o, { ...t, ref: n, className: P(a == null ? void 0 : a[r], t.className) });
      });
    }
  };
};
export {
  y as createStyleContext
};
